// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"58118025","557":"37e2d3a7","787":"bf0f9672"}[chunkId] + ".chunk.js";
};